<template>
  <v-data-table
    mobile-breakpoint="0"
    item-key="id"
    :options.sync="tableOptions"
    :server-items-length="totalItems"
    :headers="headers"
    :items="groupHeadfees"
    :footer-props="footerTable"
    v-bind="this.$attrs"
    loading-text="Đang Tải"
    :loading="loading"
    :items-per-page="5"
    disable-sort
  >
    <template v-slot:no-data>
      <div class="my-14 font-weight-bold">Hiện tại chưa có {{ getText(group.type) }} trong danh sách.</div>
    </template>
    <template v-slot:[`item.title`]="{ item }">
      <router-link :to="{ path: `/head-fees/${item.salary_head.id}` }" class="text-decoration-none">{{
        item.salary_head ? item.salary_head.title : ''
      }}</router-link>
    </template>
    <template v-slot:[`item.type`]="{ item }">
      {{ item.salary_head ? item.salary_head.salary_head_apply.title : '' }}
    </template>
    <template v-slot:[`item.category`]="{ item }">
      <span v-if="item.salary_head">{{ item.salary_head.category == 'custom' ? 'Bổ sung' : 'Mặc định' }}</span>
    </template>
    <template v-slot:[`item.note`]="{ item }">
      <v-tooltip max-width="250px" bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="text-truncate" style="max-width: 250px;">
            {{ item.salary_head ? item.salary_head.note : '' }}
          </div>
        </template>
        <span class="tooltip white--text">{{ item.salary_head ? item.salary_head.note : '' }}</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { getGroupHeadHeaders } from './utils'

export default {
  data() {
    return {
      tableOptions: {},
      selected: []
    }
  },
  props: {
    category: {
      type: String,
      default: 'main'
    }
  },
  computed: {
    ...mapState('salaryGroupHead', ['totalItems', 'pageText', 'groupHeadfees', 'loading', 'groupHeadfeesSearchParams']),
    ...mapGetters({
      group: 'salaryGroup/groupInfo'
    }),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số khoản phí mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
    headers() {
      return getGroupHeadHeaders(this.category)
    }
  },
  methods: {
    ...mapActions('salaryGroupHead', ['requestPageSettings']),
    getText(category) {
      switch (category) {
        case 'normal': {
          return 'khoản phí'
        }
        case 'priority': {
          return 'khoản giảm trừ'
        }
      }
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
            id: this.$route.params.id
          })
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: max-content;
  max-width: 100%;
}
.tooltip {
  word-wrap: break-word;
}
</style>
